@let view = data();

<ui-headlines [data]="view.headlines" [level]="1"></ui-headlines>

<div [innerHtml]="view.content | bypassSecurity"></div>
